import { components, paths } from "@api/api";
import useAxios from "@hooks/useFetch";

const EXPERIENCE_ENDPOINT: keyof paths = '/api/Item/GetExperience';

export type ProfileExperienceRequest = components["schemas"]["FlavorTracker.Entities.DTO.ItemPage.ItemExperienceRequest"];
export type ProfileExperienceResponseItem = components["schemas"]["FlavorTracker.Entities.DTO.ItemPage.ItemExperienceAffinityByMetric"];
export type ProfileExperienceResponse = ProfileExperienceResponseItem[];

export function useProfileExperience(
    payload: ProfileExperienceRequest,
): {
    isLoading: boolean;
    data: ProfileExperienceResponse;
} {
    const response = useAxios<ProfileExperienceResponse, ProfileExperienceRequest>({
        url: EXPERIENCE_ENDPOINT,
        method: 'post',
        payload,
    });

    return {
        ...response,
        data: response.data ?? [],
    };
}